import { styled } from 'styled-components'
import { VStack } from '@musinsa/mwms-ds'

export const PageLayout = styled(VStack)`
  height: 100%;
  gap: 16px;
`
